import { toast } from 'react-toastify';

/** 전역 ToastContainer(GlobalToastHost)의 containerId 와 동일해야 함 */
export const APP_TOAST_CONTAINER_ID = "app-global-toast-v1";

const defaultToastOptions = {
  containerId: APP_TOAST_CONTAINER_ID,
  position: "bottom-center",
  autoClose: 2500,
  closeButton: false,
  hideProgressBar: true,
  pauseOnHover: true,
  draggable: true,
  pauseOnFocusLoss: false,
  style: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: '#fff',
    width: '95%',
    margin: '10px auto',
    borderRadius: '4px',
    minHeight: 'auto',
    fontSize: '14px',
    textAlign: 'center',
  },
};

export const useToast = () => {
  const showDeleteToast = (message) => {
    // 중복 토스트 방지를 위해 기존 토스트 제거 후 새로 표시
    toast.dismiss();
    toast(message, defaultToastOptions);
  };

  const showErrorToast = (message) => {
    toast(message, {
      ...defaultToastOptions,
      style: {
        ...defaultToastOptions.style,
        backgroundColor: 'rgba(220,53,69,0.9)', // 에러용 빨간색 배경
      },
    });
  };

  const showSuccessToast = (message) => {
    toast(message, {
      ...defaultToastOptions,
      style: {
        ...defaultToastOptions.style,
        backgroundColor: 'rgba(40,167,69,0.9)', // 성공용 초록색 배경
      },
    });
  };

  return {
    showDeleteToast,
    showErrorToast,
    showSuccessToast,
  };
}; 